import { UserProfile } from '../types/user';

export const demoUsers: Partial<UserProfile>[] = [
  {
    id: 'user-1',
    username: 'TechMaster486',
    name: 'Sophie',
    surname: 'Anderson',
    email: 'sophie@gocity.me',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
    role: 'developer',
    region: {
      continent: 'Europe',
      country: 'United Kingdom',
      city: 'London'
    }
  },
  {
    id: 'user-2',
    username: 'CodeArtisan92',
    name: 'Klaus',
    surname: 'Weber',
    email: 'klaus@gocity.me',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
    role: 'developer',
    region: {
      continent: 'Europe',
      country: 'Germany',
      city: 'Berlin'
    }
  },
  {
    id: 'user-3',
    username: 'TechPioneer234',
    name: 'Oluwaseun',
    surname: 'Adebayo',
    email: 'seun@gocity.me',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150',
    role: 'developer',
    region: {
      continent: 'Africa',
      country: 'Nigeria',
      city: 'Lagos'
    }
  }
];